import { Component, computed, inject } from '@angular/core';
import { HistoryFacade } from '../../../../../state/user/history/history.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import { Util } from '../../../../../util';

@Component({
  selector: 'app-user-history-stats-dialog',
  templateUrl: './user-history-stats-dialog.component.html',
  styleUrls: ['./user-history-stats-dialog.component.scss']
})
export class UserHistoryStatsDialogComponent {
  private readonly historyFacade = inject(HistoryFacade);

  readonly isStatsModalOpen = toSignal(this.historyFacade.isStatsModalOpen$);
  readonly isLoading = toSignal(this.historyFacade.isLoading$);
  readonly historyItemStats = toSignal(this.historyFacade.historyItemStats$);
  readonly selectedHistoryItem = toSignal(this.historyFacade.selectedHistoryItem$);
  readonly icon = computed(() => {
    if (this.historyItemStats()) {
      return Util.resolveIcon(this.historyItemStats().format, this.historyItemStats().iconId);
    }

    return null;
  });

  close() {
    this.historyFacade.closeStatsModal();
  }
}
